import { useCompany } from '@api/settings';
import Loader from '@components/Loader/Loader';
import React, { FC } from 'react';
import CompanySettings from './CompanySettings';

const CompanySettingsSkeleton: FC = () => {
	const { isLoading, data } = useCompany();
	return (
		<Loader isLoading={isLoading} variant="rectangular">
			<CompanySettings data={data!} />
		</Loader>
	);
};

export default CompanySettingsSkeleton;
